<template>
    <transition appear name="fade-transition">
        <span class="display__string">
            <app-tooltip :value="tooltipValue" :disabled="tooltipDisabled">
                {{ displayValue }}
            </app-tooltip>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayString',
    extends: Display
};
</script>

<style lang="scss" scoped>
.display__string {
    min-width: 7rem;
}
</style>
